import { EllipsisVertical } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import MainContainer from "../../components/container/MainContainer";
import AppHeader from "../../components/header/AppHeader";
import { openModal } from "../../features/modalSLice";
import Modal from "../../components/modal/Modal";
import {
  getProjectStatuses,
  unsetProjectStatuses,
} from "../../features/projectStatusesSlice";
import {
  getProjectRequests,
  getProjects,
  unsetProjects,
} from "../../features/projectsSlice";
import { Link, useLocation } from "react-router-dom";
import Table from "../../components/tables/Table";
import Loading from "../../components/loading/Loading";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const Project = () => {
  const [mode, setMode] = useState("table"); //Table or card form
  const dispatch = useDispatch();
  const projects = useSelector((state) => state.projects.data);
  const projectsLoading = useSelector(
    (state) => state.projects.load.getProjects
  );
  const projectRequestsLoading = useSelector(
    (state) => state.projects.load.getProjectRequests
  );
  const projectStatuses = useSelector((state) => state.projectStatuses.data);
  const modalContent = useSelector((state) => state.modal.content);
  const location = useLocation();
  const requestPath = location.pathname === "/project-requests";

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Title" },
    { id: "status", text: "Status" },
    { id: "community", text: "Community" },
  ];

  const openAddProjectModal = () => {
    // dispatch(openModal(<AddProject edit={false} />));
  };

  useEffect(() => {
    dispatch(getProjectStatuses());
    // if (requestPath) dispatch(getProjectRequests());
    // else dispatch(getProjects());

    return () => {
      dispatch(unsetProjectStatuses());
      dispatch(unsetProjects());
    };
  }, []);

  useEffect(() => {
    if (requestPath) dispatch(getProjectRequests());
    else dispatch(getProjects());
  }, [requestPath]);

  if (
    projectsLoading === loadStatus.loading ||
    projectRequestsLoading === loadStatus.loading
  ) {
    return <Loading />;
  }

  if (
    projectsLoading === loadStatus.error ||
    projectRequestsLoading === loadStatus.error
  ) {
    return <NetworkError to={location.pathname} />;
  }

  //The mode cover the table mode or card view mode

  return (
    <MainContainer>
      <AppHeader
        title={`${requestPath ? "Project Requests" : "Projects"}`}
        link="/projects/add-project"
        links={projectStatuses}
        addAction={openAddProjectModal}
        mode={mode}
        setMode={setMode}
        requestPath={requestPath}
      />
      {mode === "table" ? (
        <Table columns={columns} data={projects} link />
      ) : (
        <main className=" overflow-auto grid grid-cols-1 sm:grid  sm:grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-3 justify-center items-center pt-3 p-4 ">
          <Modal>{modalContent}</Modal>
          {projects.map((item) => (
            <article
              key={item.id}
              className="project-card bg-white px-3 py-4 flex flex-col rounded-md"
            >
              <div className="flex justify-between items-center py-6 gap-1">
                <Link
                  className="text-indigo-800 text-base sm:text-xl font-semibold text-left"
                  to={`/projects/${item.id}`}
                >
                  {item.name}
                </Link>

                <div>
                  <EllipsisVertical size={20} />
                </div>
              </div>
              {/* Status */}
              <div className="pb-4">
                <div className="text-xs px-1 py-0.5 bg-green-500 text-white text-center leading-4 inline-block justify-center items-center rounded-full">
                  {
                    projectStatuses.find(
                      (status) => item.status_id === status.id
                    ).name
                  }
                </div>
              </div>
              {/* Rest */}
              <div>
                <h3 className="text-xs sm:text-base">
                  <span className="font-semibold">Due Date </span> :{" "}
                  {new Date(item.planned_end_date).toDateString()}
                </h3>
                <p className="py-2 text-sm ">{item.short_description}</p>
                <figure className="flex flex-col gap 1 py-3">
                  <h3 className="text-gray-500 font-semibold">MEMBERS</h3>
                  <div className="flex">
                    <div className="hidden-avatar w-9 rounded-full text-white text-xs bg-green-600 flex justify-center items-center border-2 border-white mr-2">
                      +10
                    </div>
                    <div className="avatar">
                      <img
                        className="w-full"
                        alt="profile"
                        src="https://cdn.pixabay.com/photo/2014/04/02/17/07/user-307993_960_720.png"
                      />
                    </div>
                    <div className="avatar">
                      <img
                        className="w-full object-cover h-full"
                        alt="profile"
                        src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_1280.png"
                      />
                    </div>
                    <div className="avatar">
                      <img
                        className="w-full object-cover h-full"
                        alt="profile"
                        src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                      />
                    </div>
                    <div className="avatar">
                      <img
                        className="w-full object-cover h-full"
                        alt="profile"
                        src="https://images.pexels.com/photos/428361/pexels-photo-428361.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                      />
                    </div>
                  </div>
                </figure>
                <section className=" flex justify-between items-center rounded-lg shadow-lg py-4  border-t border-t-gray-100 p-4">
                  <div>
                    <p>7</p>
                    <h4>Tasks</h4>
                  </div>
                  <div className="text-right">
                    <p>0</p>
                    <h4>Comments</h4>
                  </div>
                </section>
              </div>
            </article>
          ))}

          {/* <article className="bg-white px-1 py-2 min-h-0"></article> */}
        </main>
      )}
    </MainContainer>
  );
};

export default Project;
